import { render, staticRenderFns } from "./MissionInfosModal.vue?vue&type=template&id=70646c0a&scoped=true&"
import script from "./MissionInfosModal.vue?vue&type=script&lang=js&"
export * from "./MissionInfosModal.vue?vue&type=script&lang=js&"
import style0 from "./MissionInfosModal.vue?vue&type=style&index=0&id=70646c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70646c0a",
  null
  
)

export default component.exports